import type { MouseEvent } from "react";
import { Trans, useTranslation } from "react-i18next";
import Modal from "../../modal-new";

interface CreateClientConfigReviewModalProps {
  isVisible: boolean;
  handleConfirmCreateReview: () => void;
  setShowCreateReviewModal: (show: boolean) => void;
}

export const CreateClientConfigReviewModal = ({
  isVisible,
  handleConfirmCreateReview,
  setShowCreateReviewModal,
}: CreateClientConfigReviewModalProps) => {
  const { t } = useTranslation(["athlete-portal", "common"]);

  if (!isVisible) return null;

  const handleCreateReviewOverlayClose = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    closeCreateReviewModal();
  };

  const closeCreateReviewModal = () => setShowCreateReviewModal(false);

  return (
    <Modal
      className="create-client-configuration-review-modal"
      title={t("clientConfiguration.createReviewModal.title")}
      onClose={handleCreateReviewOverlayClose}
    >
      <div className="body">
        <span>
          <Trans
            t={t}
            i18nKey="clientConfiguration.createReviewModal.body"
            components={{ 1: <strong /> }}
          />
        </span>
      </div>
      <footer className="client-config-footer-buttons">
        <div className="right-content">
          <button
            type="button"
            data-button-type="secondary"
            onClick={closeCreateReviewModal}
          >
            {t("common:cancel")}
          </button>
          <button
            type="button"
            data-button-type="primary"
            onClick={handleConfirmCreateReview}
          >
            {t("clientConfiguration.createReviewModal.confirm")}
          </button>
        </div>
      </footer>
    </Modal>
  );
};
